import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AbstractInputSettings } from '../abstract-input-settings.component';
import { SettingsHeaderComponent } from '../settings-header/settings-header.component';

@Component({
  selector: 'h3-numeric-input-settings',
  templateUrl: './numeric-input-settings.component.html',
  styleUrl: './numeric-input-settings.component.scss',
  imports: [
    MatFormFieldModule,
    AsyncPipe,
    MatInputModule,
    FormsModule,
    SettingsHeaderComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumericInputSettingsComponent extends AbstractInputSettings<number> {
  @Input({ required: true }) min!: number;
  @Input({ required: true }) step!: number;
}
